var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("AppSocialNetworkButtons")]),_c('div',{staticClass:"wrapper"},[_c('AppSocialNetworkButtons',{attrs:{"facebook-url":_vm.facebookUrl,"instagram-url":_vm.instagramUrl,"whatsapp-url":_vm.whatsappUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }